<template>
  <svg aria-hidden="true" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.6814 40.32C28.3702 40.32 28.1599 40.5568 28.1599 40.7982V53.76H26.8799V40.7982C26.8799 39.8045 27.7096 39.04 28.6814 39.04H35.3184C36.2902 39.04 37.1199 39.8045 37.1199 40.7982V53.76H35.8399V40.7982C35.8399 40.5568 35.6295 40.32 35.3184 40.32H28.6814Z"
      fill="#FF0064"
    />
    <path
      d="M34.8799 47.68C34.8799 48.2102 34.4501 48.64 33.9199 48.64C33.3897 48.64 32.9599 48.2102 32.9599 47.68C32.9599 47.1498 33.3897 46.72 33.9199 46.72C34.4501 46.72 34.8799 47.1498 34.8799 47.68Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.0001 25.6001C30.2328 25.6001 28.8001 27.0328 28.8001 28.8001C28.8001 30.5674 30.2328 32.0001 32.0001 32.0001C33.7674 32.0001 35.2001 30.5674 35.2001 28.8001C35.2001 27.0328 33.7674 25.6001 32.0001 25.6001ZM27.5201 28.8001C27.5201 26.3259 29.5259 24.3201 32.0001 24.3201C34.4744 24.3201 36.4801 26.3259 36.4801 28.8001C36.4801 31.2743 34.4744 33.2801 32.0001 33.2801C29.5259 33.2801 27.5201 31.2743 27.5201 28.8001Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M32.6401 24.3201V33.2801H31.3601V24.3201H32.6401Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M27.5201 28.1601H36.4801V29.4401H27.5201V28.1601Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.04014 37.7601C7.04014 36.6997 7.89975 35.8401 8.96014 35.8401H14.0801C15.1405 35.8401 16.0001 36.6997 16.0001 37.7601V47.3601C16.0001 48.4205 15.1405 49.2801 14.0801 49.2801H8.96014C7.89975 49.2801 7.04014 48.4205 7.04014 47.3601V37.7601ZM8.96014 37.1201C8.60667 37.1201 8.32014 37.4066 8.32014 37.7601V47.3601C8.32014 47.7136 8.60667 48.0001 8.96014 48.0001H14.0801C14.4336 48.0001 14.7201 47.7136 14.7201 47.3601V37.7601C14.7201 37.4066 14.4336 37.1201 14.0801 37.1201H8.96014Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1601 36.4801V49.2801H10.8801V36.4801H12.1601Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.68014 41.6001H15.3601V42.8801H7.68014V41.6001Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M48.0001 37.7601C48.0001 36.6997 48.8597 35.8401 49.9201 35.8401H55.0401C56.1005 35.8401 56.9601 36.6997 56.9601 37.7601V47.3601C56.9601 48.4205 56.1005 49.2801 55.0401 49.2801H49.9201C48.8597 49.2801 48.0001 48.4205 48.0001 47.3601V37.7601ZM49.9201 37.1201C49.5667 37.1201 49.2801 37.4066 49.2801 37.7601V47.3601C49.2801 47.7136 49.5667 48.0001 49.9201 48.0001H55.0401C55.3936 48.0001 55.6801 47.7136 55.6801 47.3601V37.7601C55.6801 37.4066 55.3936 37.1201 55.0401 37.1201H49.9201Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M53.1201 36.4801V49.2801H51.8401V36.4801H53.1201Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M48.6401 41.6001H56.3201V42.8801H48.6401V41.6001Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8401 26.2401C20.1936 26.2401 20.4801 26.5266 20.4801 26.8801V53.7601C20.4801 54.1136 20.1936 54.4001 19.8401 54.4001C19.4867 54.4001 19.2001 54.1136 19.2001 53.7601V26.8801C19.2001 26.5266 19.4867 26.2401 19.8401 26.2401Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.1601 26.2401C44.5136 26.2401 44.8001 26.5266 44.8001 26.8801V53.7601C44.8001 54.1136 44.5136 54.4001 44.1601 54.4001C43.8067 54.4001 43.5201 54.1136 43.5201 53.7601V26.8801C43.5201 26.5266 43.8067 26.2401 44.1601 26.2401Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.54687 10.8801C6.49373 10.8801 6.40841 10.9204 6.37599 11.0383L1.9303 27.2101C1.92364 27.2343 1.92014 27.2599 1.92014 27.286C1.92014 27.4536 2.03838 27.5201 2.10119 27.5201H17.6317V28.8001H2.10119C1.25708 28.8001 0.640137 28.0838 0.640137 27.286C0.640137 27.1458 0.658896 27.0061 0.696088 26.8708L5.14177 10.6991C5.3142 10.0718 5.87076 9.6001 6.54687 9.6001H57.4532C58.1293 9.6001 58.6859 10.0718 58.8583 10.6991L63.304 26.8708C63.5147 27.6372 63.113 28.4888 62.3199 28.7359C62.1837 28.7784 62.0418 28.8001 61.8989 28.8001H46.3684C46.0149 28.8001 45.7284 28.5136 45.7284 28.1601C45.7284 27.8066 46.0149 27.5201 46.3684 27.5201H61.8989C61.912 27.5201 61.9255 27.5181 61.9391 27.5139C62.0164 27.4898 62.1138 27.3702 62.0698 27.2101L57.6241 11.0383C57.5916 10.9204 57.5063 10.8801 57.4532 10.8801H6.54687Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.84014 27.5201C4.1936 27.5201 4.48014 27.8066 4.48014 28.1601V53.1201H59.5201V28.1601C59.5201 27.8066 59.8067 27.5201 60.1601 27.5201C60.5136 27.5201 60.8001 27.8066 60.8001 28.1601V53.7601C60.8001 54.1136 60.5136 54.4001 60.1601 54.4001H3.84014C3.48667 54.4001 3.20014 54.1136 3.20014 53.7601V28.1601C3.20014 27.8066 3.48667 27.5201 3.84014 27.5201Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.2449 16.8866C31.6947 16.5579 32.3055 16.5579 32.7554 16.8866L49.3954 29.0466C49.9661 29.4637 50.0907 30.2646 49.6736 30.8353C49.2565 31.4061 48.4557 31.5307 47.8849 31.1136L32.0001 19.5055L16.1154 31.1136C15.5446 31.5307 14.7438 31.4061 14.3267 30.8353C13.9096 30.2646 14.0342 29.4637 14.6049 29.0466L31.2449 16.8866Z"
      fill="#05070F"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'AssistedLivingIcon',
};
</script>
